module.exports = __webpack_public_path__ + "img/account-icon.20cec413.svg";